export const CAT42_VH_USER = 'cat42-user';
export const CAT42_SIDEBAR_COLLAPSED = 'cat42-sidebar-collapsed';
export const CAT42_AUTH = 'cat42-auth';
export const CAT42_REMEMBER_LOGIN = 'cat42-remember';
